import React from 'react'

import { ToggleButton } from '@/shared/components'
import { ToggleButtonGroup } from '@mui/material'

import { useSummaryTableContext } from './SummaryTableContext'

export type SummaryTableToolbarActionsProps = {
  //
}

export const SummaryTableToolbarActions: React.FC<SummaryTableToolbarActionsProps> = ({ }) => {
  const { showSummaryTable, toggleSummaryTable } = useSummaryTableContext()

  return (
    <ToggleButtonGroup
      value={showSummaryTable}
      exclusive
      onChange={() => {
        toggleSummaryTable()
      }}
      aria-label="Show Summary Table"
    >
      <ToggleButton
        value={false}
        primary
        text
      >
        Runs
      </ToggleButton>
      <ToggleButton
        value={true}
        primary
        text
      >
        Summary
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
